export { processUriTemplate } from './dash/processUriTemplate.js';
